import type { UnknownAction } from '@reduxjs/toolkit';

export const matcher = (action: UnknownAction) =>
  action.type?.startsWith('error/') || action.type?.endsWith('_ERROR');
